/*
 * @Description:
 */

export default {
  common: {
    setSuccess: 'Setup successful',
    cancelSuccess: 'Cancel successful',
    selectDateTip: 'Please select a date',
    notes: 'Notes',
    append: 'Append',
    indexNumber: 'index',
    deleteStatus: 'Delete status',
    serialNumber: '编号',
    qty: '数量',
    search: '检索',
    reset: '重置',
    submit: '提交',
    delete: '删除',
    edit: '编辑',
    examine: '查看',
    operate: '操作',
    operateSuccess: '操作成功！',
    updateSuccess: '更新成功！',
    createSuccess: '创建成功！',
    deleteTip: '此操作将删除此条记录, 是否继续?',
    deleteSuccess: '删除成功！',
    cancelDelete: '已取消删除！',
    create: '创建',
    isActive: '是否可用',
    active: '可用',
    notActive: '不可用',
    isRequired: '是必需的',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    minNumber: '最小值为: ',
    add: '添加',
    end: '结束',
    next: '下一步',
    value: '值',
    finish: '完成',
    inputSearch: '请输入搜索信息并Enter!',
    baseInfo: '基本信息',
    needQuantity: '所需数量',
    save: 'save',
    all: 'all',
    yes: 'yes',
    no: 'no',
    downloadTip: '点击文件名下载',
    noData: '暂无数据',
    none: '无',
    cancel: '取消',
    time: '时间',
    completed: 'completed',
    canceled: 'canceled',
    rejected: 'rejected',
    reject: 'reject',
    max100WordsTip: 'No more than 100 words',
    select: 'select',
    isProcess: 'is Process',
    back: '返回',
    onCapsLock: 'Caps lock is On',
    setDefault: 'Set as default',
    batchImport: '批量导入',
    hasApproved: '已通过',
    partiallyPassed: '部分通过',
    downloadTemplate: '下载模板',
    inputFormatP: '输入格式错误',
    greaterThanZeroP: '输入的值需大于0',
    loading: 'Loading...',
    copySuccess: 'Copy Successful',
    copyError: 'Copy Failed',
    exportExcel: 'Excel导出'
  },
  route: {
    dashboard: '首页',
    userInfo: 'User Info',
    resetPassword: 'Password Change',
    mfaBind: 'MFA Bind',
    mainDataManagement: 'Master Data Management',
    company: 'Company',
    companyDetails: '公司主数据详情',
    companyCreate: '添加公司主数据',
    companyUpdate: '修改公司主数据',
    supplier: 'Supplier',
    supplierCreate: '添加供应商主数据',
    supplierUpdate: '修改供应商主数据',
    employee: 'Employee',
    employeeCreate: '添加员工主数据',
    employeeUpdate: '修改员工主数据',
    applicationFormManagement: 'Application Form Management',
    paymentRequestSAP: 'Payment Request (SAP)',
    specialPaymentRequestPO: 'Special Payment Request (PO)',
    createSpecialPaymentRequestPO: 'Create Special Payment Request (PO)',
    updateSpecialPaymentRequestPO: 'Update Special Payment Request (PO)',
    specialPaymentRequestNoPO: 'Special Payment Request (No PO)',
    createSpecialPaymentRequestNoPO: 'Create Special Payment Request (No PO)',
    updateSpecialPaymentRequestNoPO: 'Update Special Payment Request (No PO)',
    reimbursementRequest: 'Reimbursement Request',
    createSpecialPaymentRequestReimb: 'Create Reimbursement Request',
    updateSpecialPaymentRequestReimb: 'Update Reimbursement Request',
    paymentRequestRefund: 'Application for refund',
    createPaymentRequestRefund: 'Create Application For Refund',
    updatePaymentRequestRefund: 'Update Application For Refund',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    system: '系统管理',
    member: '用户管理',
    role: '角色管理',
    permission: '权限管理',
    approvalFormManagement: '审批单管理',
    approvalForm: '审批单处理',
    returnApprovalForm: '返回审批列表',
    approvalFormDetail: '审批单详情',
    approvalFormHistory: '历史审批单',
    approvalFormHistoryDetail: '历史审批单详情',
    process: '审批流管理',
    processEdit: '编辑审批流信息',
    paymentSlipManagement: '支付管理',
    PlannedPaymentSlip: '计划支付单',
    plannedPaymentSlipReports: '计划支付单报表',
    outsidePaymentSlip: '外汇或体外支付单',
    pendingExecutionPaymentSlip: '待执行支付单',
    paymentSlipBufferDetailDetail: '待执行支付单详情',
    paymentSlipDetails: '支付单详情',
    paymentSlipHistory: '历史支付单',
    paymentSlipHistoryCashDetail: '历史支付单详情',
    paymentSlipHistoryAcceptanceDetail: '支付单详情',
    plannedPaymentSlipDetail: '计划支付单-支付详情',
    acceptanceManagement: '承兑票管理',
    acceptanceReceive: '承兑票接收',
    acceptanceReceiptDetail: '承兑票详情',
    acceptanceApproval: '承兑票审批',
    acceptanceApprovalDetail: '审批详情',
    acceptanceApprovalHistory: '承兑票审批历史',
    acceptanceApprovalHistoryDetail: '审批详情',
    acceptanceHistory: '历史承兑票',
    acceptanceHistoryDetail: '承兑票详情',
    paymentStatement: '交易流水',
    downloadHistoryReceipt: '下载历史回单',
    acceptanceBillsList: '承兑票清单',
    acceptanceBillsDetail: '承兑票清单详情'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    theme: 'Theme',
    size: 'Global Size',
    profile: 'Profile',
    userInfo: 'User Info',
    resetPassword: 'Password Change',
    setMFA: 'MFA Binding/Unbinding'
  },
  login: {
    title: 'CEFWARE',
    logIn: 'Login',
    username: 'Username',
    password: 'Password'
  },
  permission: {
    name: '权限名称',
    createRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    createSuccessMessage: '创建成功',
    editSuccessMessage: '更新成功',
    deleteTipMessage: '此操作将删除权限, 是否继续?',
    cancelDeleteMessage: '已取消权限删除',
    delete: 'Delete',
    edit: '编辑权限',
    confirm: 'Confirm',
    cancel: 'Cancel',
    create: '新增权限',
    permissionUrl: '权限路径',
    permissionAuth: '权限编码',
    permissionLv: '权限层级',
    parentPermissionName: '父权限名'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Importance',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'Reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  user: {
    name: '用户名',
    account: '访问id',
    roleNames: '用户角色',
    password: '密码',
    passwordConfirm: '密码确认',
    create: '用户创建',
    edit: '用户编辑',
    updatePassword: '修改用户密码',
    createSuccessMessage: '创建成功',
    editSuccessMessage: '更新成功',
    deleteTipMessage: '此操作将删除用户, 是否继续?',
    cancelDeleteMessage: '已取消用户删除',
    deleteMessage: '删除成功',
    mailAddress: '邮箱',
    department: '部门',
    isActive: '是否活跃',
    changePasswordInitializeMessage: '初始化密码',
    confirmChangePasswordMessage: '确认初始化密码？',
    passwordInitializedMessage: '密码已初始化并发送给用户',
    cancelPasswordInitializedMessage: '已取消初始化密码',
    loginUser: '登录名'
  },
  role: {
    name: '角色名',
    edit: '编辑角色',
    create: '创建角色',
    editAuthorization: '编辑角色权限',
    permissions: '角色权限',
    allPermissions: '全部权限',
    createSuccessMessage: '创建成功',
    editSuccessMessage: '更新成功',
    deleteTipMessage: '此操作将删除角色, 是否继续?',
    cancelDeleteMessage: '已取消删除角色',
    deleteMessage: '删除成功',
    noRoleId: '没有角色id',
    updateAuthorizationSuccessMessage: '编辑角色权限成功'
  },
  dommonData: {
    name: '名称',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    isActive: '是否活跃',
    active: '活跃',
    notActive: '非活跃'
  },
  message: {
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    yes: '是',
    no: '否'
  },
  form: {
    selectPlaceholder: '请选择',
    isRequired: '是必需的',
    passwordNotMatch: '两次输入密码不一致'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  errorMsg: {
    notFound: 'not found',
    checkError: 'check error',
    checkEmptyError: 'can not be empty',
    checkExistError: 'already exists',
    canNotDelete: 'can not delete',
    dataNotMatch: 'data does not match',
    internalError: 'internal error'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    showTagsView: 'Open Tags-View',
    showSidebarLogo: 'Sidebar Logo',
    fixedHeader: 'Fixed Header',
    sidebarTextTheme: 'Sidebar Text Theme'
  },
  userInfo: {
    userAccount: 'Account',
    userName: 'User Name',
    mailAddress: 'Email Address',
    userRoleNames: 'Role',
    department: 'Department'
  },
  restPassword: {
    originalPassword: 'Original Password',
    oriPasswordP: 'The original password cannot be empty.',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    lengthP: 'Password must be longer than 10 characters!',
    ruleP: 'Must include numbers, special characters, and uppercase and lowercase letters!',
    repeatAccountP: 'Passwords must not match the account!',
    differentP: 'Does not match the new password entered!'
  },
  mfa: {
    mfaBind: 'MFA binding',
    mfaStatus: 'MFA Status',
    unbound: 'Unbound',
    bonded: 'Already bound',
    bindNow: 'Bind Now',
    rebind: 'Rebind',
    password: 'Password',
    passwordP: 'Password cannot be empty.',
    mfaBindTip: 'Please install the Authenticator app on your phone.\n After scanning the QR code to bind your account, enter the verification code below.',
    mfaChecksum: 'MFA Checksum',
    mfaChecksumP: 'MFA Checksum cannot be empty.',
    bind: 'Bind'
  },
  bank: {
    bankInfo: 'Bank Information',
    selectBankInfoP: 'Please select bank details',
    bankInfoP: 'Bank Information cannot be empty.',
    bankAccount: 'Bank Account',
    bankAccountP: 'Bank Account cannot be empty.',
    bankCode: 'Bank Code',
    bankCodeP: 'Bank Code cannot be empty.',
    bankNumber: 'Bank Number',
    bankNumberP: 'Bank Number cannot be empty.',
    bankName: 'Bank Name',
    bankNameP: 'Bank Name cannot be empty.',
    paymentTerms: 'Payment cycle (days)',
    paymentTermsP: 'Payment cycle cannot be left blank',
    isForeignExchange: 'Foreign Exchange',
    isForeignExchangeOrExternal: 'Foreign Exchange (or off-site payment)',
    isForeignExchangeOrExternalP: 'Foreign Exchange (or off-site payment) cannot be empty.',
    isPriorityAcceptanceBill: '承兑优先使用',
    isPriorityAcceptanceBillP: '承兑优先使用不能为空',
    amount: 'Amount',
    amountP: 'Amount cannot be empty.',
    totalAmount: 'Total Amount',
    currency: 'Currency',
    currencyP: 'Currency cannot be empty.',
    bankCity: 'Bank Location',
    bankCityP: 'Bank Location cannot be empty.',
    amountApproved: '已通过金额'
  },
  company: {
    companyMaster: 'Company Master Data',
    companyName: 'Company Name',
    companyNameP: 'Company Name cannot be empty.',
    companyCode: 'Company Code',
    companyCodeP: 'Company Code cannot be empty.'
  },
  employee: {
    employeeP: 'Employee data must not be empty.',
    employeeMaster: 'Employee Master Data',
    nameCn: 'Chinese name',
    nameCnP: 'Chinese name cannot be empty.',
    nameEn: 'English name',
    nameEnP: 'English name cannot be empty.',
    employeeId: 'Employee ID',
    employeeIdP: 'Employee ID cannot be empty.',
    employingCompany: 'Employing Company',
    employingCompanyP: 'Employing Company cannot be empty.',
    email: 'Email',
    emailIsNull: 'Email cannot be empty.',
    emailIsError: 'The email format is invalid.',
    employeeNumber: 'Employee ID number',
    employeeName: 'Employee Name'
  },
  supplier: {
    supplierMaster: 'Supplier Master Data',
    supplierCode: 'Supplier Code',
    supplierName: 'Supplier Name',
    supplierNameP: 'Supplier Name cannot be empty.',
    supplierCodeP: 'Supplier Code cannot be empty.',
    selectSupplierP: 'Please select a supplier',
    customerName: 'Customer Name',
    customerNameP: 'Customer Name cannot be empty.'
  },
  order: {
    orderOperations: 'Order Operations',
    orderFunctions: 'Order Functions',
    selectTip: 'Please select the order to configure.',
    setPaymentDate: 'Set Payment Date',
    setPaymentDateP: 'The payment date cannot be empty.',
    selectedApplicationForm: 'Selected Application Form',
    cancelApplication: 'Cancel Application',
    batchUpload: 'Batch Upload',
    generateApprovalForm: 'Generate Approval Form',
    documentNumber: 'Document Number',
    invoiceNumber: 'Invoice Number',
    cutOffDate: 'Maturity date',
    paymentDate: 'Payment Date',
    paymentDateP: 'Payment Date cannot be empty.',
    purposePayeeMayView: 'Purpose (visible to payee)',
    purposePayeeMayViewNullP: 'Purpose (visible to payee) cannot be empty.',
    purposePayeeMayViewP: 'Please enter the purpose (visible to the payee)',
    isCompanyAccount: 'Is it Corporate',
    isCompanyAccountP: 'Is it Corporate cannot be empty.',
    paymentDocuments: '付款支持文件'
  },
  approvalForm: {
    approvalFormList: 'Pending Approval Form',
    deadline: 'deadline',
    currentApprover: 'Current approver',
    submitDate: 'submitDate',
    submitter: 'submitter',
    id: 'id',
    toBeSubmitted: 'to be submitted',
    pendingLevel1Approval: 'pending level 1 approval',
    pendingLevel2Approval: 'pending level 2 approval',
    pendingLevel3Approval: 'pending level 3 approval',
    approvalFormDetail: 'approvalForm detail',
    documentNumber: 'document number',
    reference: 'reference',
    amount: 'amount',
    currency: 'currency',
    dueDate: 'dueDate',
    text: 'remarks',
    paymentDate: 'payment date',
    purpose: 'purpose',
    purposeP: 'purpose cannot be empty.',
    specialPaymentType: 'payment type',
    specialPaymentTypeP: 'Payment type cannot be empty.',
    comment: 'remarks',
    approvalFormHistoryList: 'History Approval Form',
    operateDate: 'operate date',
    cancelSelect: 'cancel select',
    cancelAll: 'cancel all',
    submit: 'submit',
    rejectSelect: 'reject select',
    rejectAll: 'reject all',
    approved: 'approved',
    rejected: 'rejected',
    cancelTip: '注意：被取消的申请单将被从页面中移除，需从新上传申请后才能再次提交。',
    cancelConfirmTip: '确认取消？',
    rejectTip: '注意：被驳回的申请单需重新上传申请后才能再次提交。',
    rejectSelected: '已选驳回项',
    rejectComment: '驳回原因',
    finalApprover: '最终审批人',
    approver: 'Approver',
    approvalResult: 'Result',
    approvalProcess: 'Approval process'
  },
  process: {
    processList: 'Approval flow management',
    processName: 'Approval flow name',
    isActive: 'Is active',
    yes: 'yes',
    no: 'no',
    id: 'id',
    companyName: 'companyName',
    active: 'active',
    processEdit: 'Approval flow edit',
    processLine: 'Approval flow Step',
    level1Approver: 'First-level approval',
    level2Approver: 'Second-level approval',
    level3Approver: 'Three-level approval',
    addApprover: 'Add approver',
    deleteApprover: 'Delete',
    save: 'save',
    hasApprover: 'Approver already exists',
    ApproverEmpty: '审批人列表不能为空'
  },
  pay: {
    payList: 'Planned payment slip',
    payListIsEmpty: 'Planned payment slip is Empty',
    payee: 'payee',
    dueDate: 'Deadline',
    currency: 'currency',
    id: 'id',
    reference: 'reference',
    amount: 'amount',
    purposeView: 'purpose(The payee may view it)',
    operation: 'Operation',
    vitro: 'Out-of-vitro payment',
    paymentOperation: 'Payment operation',
    setPaymentDate: 'Set payment date',
    viewAndPay: 'View and pay',
    cancelPay: 'Cancel pay',
    cancelTip: '注意：被取消的支付单将被从页面中移除，需重新上传申请并审批后才能再次支付。',
    cancelConfirmTip: '确认取消？',
    selectTip: '请选择支付单',
    vendorName: 'Vendor name',
    vendorComment: 'Vendor Comment',
    paymentDate: 'Payment date',
    paymentDateP: 'Payment Date cannot be empty.',
    purpose: 'purpose',
    comment: 'comment',
    uploadPaymentReceipt: 'Upload payment receipt',
    cancel: 'cancel',
    confirmPay: 'confirm',
    ReceiptCertificate: 'Receipt Certificate',
    PaymentBank: 'Payment Bank',
    PaymentBankNO: '付款银行账号',
    PaymentBankNumber: '付款银行行号',
    PaymentBankName: '付款银行名称',
    ReceivingBank: 'Receiving Bank',
    ReceivingBankNO: '收款银行账号',
    ReceivingBankNumber: '收款银行行号',
    ReceivingBankName: '收款银行名称',
    PaymentAmount: 'amount',
    paymentDay: 'Payment date',
    paymentDetail: 'Payment detail',
    cashStatusSimulation: 'Cash status simulation',
    Remove: '移除',
    Splitting: '拆分',
    CancelSplitting: '取消拆分',
    AcceptancePayment: '承兑支付',
    HasAcceptancePayment: '已承兑支付',
    CheckAcceptancePayment: '查看承兑票',
    InsertPaymentBuffer: '加入支付序列',
    bankCode: '银行编号',
    bankName: '银行名称',
    bankAccount: '银行账号',
    confirm: '确认',
    selectPaymentBank: '选择付款银行',
    selectReceiveBank: '选择收款银行',
    selectAcceptanceReceiveBank: '选择承兑票收款银行',
    comments: '备注',
    workPaymentDeleteP: '注意：被排除的支付单将回到计划支付单中，如果需要可以再次支付。\r\n确认排除？',
    slipPayment: '拆分支付单',
    toBeSlipPayment: '待拆分支付单',
    slipAmount: '拆分金额',
    slipAmountP: '拆分金额过大，无法拆分',
    slipAmountCannotBeZeroP: '拆分金额需大于0',
    afterSlipPayment: '拆分后支付单',
    preView: '预览',
    cancelSlipPayment: '取消拆分支付单',
    toBeCancelSlipPayment: '待取消拆分支付单',
    afterCancelSlipPayment: '取消拆分后支付单',
    workPaymentSubmitP: '注意：加入支付序列后，系统将根据付款日期自动触发付款。如需取消付款或修改付款日，可在待执行支付单内操作。\n确认加入？',
    paymentHistory: '历史支付单',
    paymentSlipType: '支付方式',
    status: '状态',
    DownloadCertificate: '凭证下载',
    viewDetails: '查看详情',
    all: '全部',
    hasPayment: '已支付',
    Cancelled: '已取消',
    BatchDownloadCertificate: '批量下载凭证',
    orderFunction: '订单功能',
    draftNo: '票据号',
    draftType: '票据种类',
    splitFlag: '可拆包标记',
    issueDate: '出票日期',
    draftBankName: '承兑人银行',
    banendFlag: '不得转让标记',
    draftAmt: '票据金额',
    payingBank: '付款银行',
    acceptanceList: '承兑票一览',
    usedAmount: '使用金额',
    paymentStatement: '交易流水',
    LoanMarking: '借贷标记',
    date: '日期',
    lend: '借',
    loan: '贷',
    transactionType: '交易类型',
    transferInto: '转入',
    transferOut: '转出',
    otherPartyName: '对方账户名称',
    statementUniqueIdentifier: '流水唯一标识号',
    accountingDate: '记账日期',
    transactionAmount: '交易金额',
    balance: '余额',
    businessType: '业务类型',
    abstractAbbreviation: '摘要简称',
    abstractDescription: '摘要描述',
    coreNote: '核心备注',
    downloadHistoryReceipt: '下载历史回单',
    paymentSlip: '支付单',
    acceptanceUse: '承兑票使用',
    useAmount: '使用金额',
    useAmountError: '使用金额错误',
    executePayment: '待执行支付单',
    updatePaymentDate: '变更付款日',
    currentAccountBalance: '当前账户余额',
    currentAvailableBalance: '当前可用余额',
    paymentAmount: '支付金额',
    payDate: '支付日期',
    uploadDropFile: 'Drop file here',
    uploadDropOr: 'or',
    uploadDropClick: 'click to upload',
    confirmVitro: '确认体外支付',
    batchOutsideConfirm: '批量体外支付确认',
    batchOutsideConfirmSuccess: '批量体外支付确认成功',
    selectForeignCurrencyTip: '不能选择体外支付单进行查看和支付',
    correlateName: '对方账户名称',
    attachInfo: '流水唯一标识号',
    trnAMT: '交易金额',
    loadMore: '加载更多',
    paymentVoucherIsNull: '支付凭证为空',
    paymentError: '支付失败',
    toBeConfirmed: '待确认',
    bankEmptyAlertMessage: '收款方银行列表为空，或在当前页面未选中收款银行',
    paymentTime: '支付时间',
    historyReceipt: '下载回单',
    slipAmountTip: '* 拆分金额需小于待拆分项支付金额',
    acceptancePayment: '承兑支付',
    acceptancePaymentTip: '* 承兑票使用总金额需等于支付单支付金额',
    vitroPayTip: '注意：请确认已在银行客户端完成支付操作后，保留支付凭证，再由本页更新支付状态。',
    acceptancePaymentConfirmTip: '* 确认后将立即支付',
    currentReceivingBank: '当前收款银行',
    showTotalAmount: '查看汇总金额',
    totalAmountPayable: '待支付总金额',
    plannedTotalAmountPayable: '计划支付单总金额',
    reportDisplayTypes: '报表显示形式',
    supplierSumDisplay: '按供应商汇总',
    singleRowDisplay: '单行信息',
    supplierSumAndSingleRowDisplay: '供应商汇总加单行信息',
    foreignExchangeOrExternal: '外汇 (或体外支付)'
  },
  fileUpload: {
    uploadText: '将文件拖到此处，或',
    clickUpload: '点击上传',
    excelFileUploadTip: '只能上传xlsx/xls文件',
    upload: '上传',
    uploadSuccess: '上传成功!',
    uploadError: '上传失败!'
  },
  Acceptance: {
    id: 'index',
    requestObject: 'requestObject',
    requestObjectName: '请求方名称',
    requestObjectBankName: '请求方开户行名称',
    requestTime: 'requestTime',
    draftNo: 'draftNo',
    draftRange: 'draftRange',
    orderFunction: 'order Function',
    viewDetails: 'view Detail',
    requestDate: 'request Date',
    draftType: 'draft Type',
    bankName: '承兑人银行',
    draftAmt: 'draft amt',
    status: 'status',
    approvalProcess: '发起签收审批',
    rejectApproval: '发起拒绝审批',
    batchAcceptance: '批量签收',
    batchAcceptanceP: '批量签收',
    selectSignatureTip: '请选择需要签收的承兑票',
    batchReject: '批量拒绝',
    selectRefuseTip: '请选择需要拒绝的承兑票',
    initiateApproval: '发起审批',
    totalAmount: '票据金额合计',
    approvalType: '审批类型',
    approvalTypeP: '审批类型不能为空',
    acceptanceReceipt: '承兑票接收',
    acceptanceReceiptDetail: '承兑票详情',
    acceptedBillsPendingApproval: '待审批承兑票',
    receiveBankName: '接收银行名称',
    banendFlag: '请求不得转让标记',
    splitFlag: '可拆包标记',
    requestEntrustPay: '请求到期无条件委托标记',
    issueDate: '出票日期',
    dueDate: '到期日',
    dueDateTime: '到期日期',
    Refuse: '拒绝',
    Signature: '签收',
    approveAcceptance: '承兑票审批',
    currentApprover: '当前审批人',
    submitDate: '提交日期',
    Submitter: '提交人',
    all: '全部',
    submitTime: '提交时间',
    finalApprover: '最终审批人',
    operationTime: '操作时间',
    historicalAcceptance: '历史承兑票',
    approvalHistory: '审批历史',
    requestBankName: '请求方开户行名称',
    responseObject: '应答方名称',
    responseBankName: '应答方开户行名称',
    banendFlagTrue: '不得转让标记',
    signupMark: '应答标识',
    approveAcceptanceHistory: '承兑票审批历史',
    approveDetail: '审批详情',
    AcceptanceTotalAmount: '票据金额合计',
    rejectionReason: '驳回原因',
    behaveNo: '行为序号',
    behaveType: '行为种类',
    behaveDate: '行为日期',
    usedAmount: '使用金额',
    dateScope: 'Issue date range',
    dueDateScope: 'Due date range',
    signForReceipt: 'Sign for receipt',
    applicationRejected: 'Application rejected',
    confirmedDismissal: '确认驳回',
    rejectionReasonTip: '注意:被驳回的承兑票将回退到待接收列表，可重新申请审批。',
    selectApprovalTip: '请选择需要审批的承兑票',
    transactionHistory: 'Transaction History',
    acceptanceBank: '接受银行'
  },
  acceptanceStatus: {
    pendingConfirmation: 'Pending confirmation',
    underReview: 'Under review',
    pendingAction: 'Pending action',
    operated: 'Operated',
    received: 'Received',
    rejected: 'Rejected'
  },
  paymentSlipTypes: {
    cash: '现汇支付',
    vitro: '体外支付',
    acceptance: '承兑支付'
  }
}
